import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom"
import './index.css';
import App from './App';
import {ErrorPage} from "./pages/error-page";
import {TicketToRidePanel} from "./components/ttr/TicketToRidePanel";
import {WelcomePanel} from "./WelcomePanel";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                path: "/",
                element: <WelcomePanel/>
            },
            {
                path: "m/:matchId",
                element: <TicketToRidePanel/>
            }
        ]
    }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);
